class ElliRecentlyViewed extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    this.load();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  async load() {
    const storageKey = 'elli-recent-products';
    const current = this.dataset.productHandle;
    let history;
    try {
      const stored = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      history = Array.isArray(stored) ? stored.filter((handle) => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle)) : [];
      history = [...new Set(history)].filter((handle) => handle !== current).slice(0, 20);
      if (current) sessionStorage.setItem(storageKey, JSON.stringify([current, ...history].slice(0, 20)));
    } catch {
      return;
    }

    const limit = Math.max(2, Math.min(8, Number(this.dataset.limit) || 6));
    const minimum = Math.max(1, Math.min(limit, Number(this.dataset.minimum) || 3));
    if (history.length < minimum) return;
    const root = (this.dataset.rootUrl || '/').replace(/\/$/, '');
    const signal = this.#controller.signal;
    const cards = await Promise.all(history.slice(0, limit).map(async (handle) => {
      try {
        const url = new URL(`${root}/products/${encodeURIComponent(handle)}`, window.location.origin);
        url.searchParams.set('section_id', 'elli-product-card');
        const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
        const response = await fetch(url, { credentials: 'same-origin', signal });
        if (!response.ok) return null;
        return new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-elli-history-card]');
      } catch {
        return null;
      }
    }));
    if (signal.aborted || !this.isConnected) return;
    const available = cards.filter(Boolean);
    if (available.length < minimum) return;
    this.querySelector('[data-elli-recent-grid]')?.replaceChildren(...available);
    this.hidden = false;
  }
}

if (!customElements.get('elli-recently-viewed')) customElements.define('elli-recently-viewed', ElliRecentlyViewed);
